export default __webpack_public_path__ + "static/media/guam_customs_and_quarantine_agency_logo.0ef1d5e0.png";